import * as Sentry from '@sentry/vue'
import { axiosFingerprintProcessor } from './sentryAxiosFingerprint'

// Split the AxiosError catch-all (PORTAL-CLIENT-5X1): group by endpoint + status
// instead of the (identical, useless) axios-internal stack. Registered on the
// global scope so it runs for every module that imports this wrapper, before
// each module's own beforeSend.
Sentry.addGlobalEventProcessor(axiosFingerprintProcessor)

export default Sentry
